import React from 'react'
import { TableRow, styled, Typography, Grid } from '@mui/material'
import { RemoveCircle } from '@mui/icons-material'
import { Table as BaseTable, TableCell as BaseTableCell, Tag, Toast as BaseToast } from '@chilecompra/react-kit'

export const AbilityReasonError = styled('div')`
  background-color: ${props => props.theme.palette.custom.red[50.07]};
  border: 1px solid ${props => props.theme.palette.red[50]};
  border-radius: 4px;
  display: ${props => props.display};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  margin-top: 16px;
  padding: 16px 24px;
`

export const AbilityTag = styled(Tag)`
  &.MuiPaper-root {
    background-color: transparent;
    color: ${props => props.color === 'warning' && props.theme.palette.yellow[50]};
    height: auto;

    & > span {
      font-weight: 700;
    }
  }
`

export const Content = styled(({ maxWidth, minWidth, textAlign, ...rest }) => <div {...rest} />)`
  max-width: ${props => props.maxWidth};
  min-width: ${props => props.minWidth};
  text-align: ${props => props.textAlign};
`

export const ErrorIcon = styled(RemoveCircle)`
  align-self: baseline;
  color: ${props => props.theme.palette.red[50]};
  height: 20px;
  padding: 0 22px 6px 10px;
  transform: rotate(129deg);
  width: auto;
`

export const MainText = styled('span')`
  font-weight: 500;
`

export const Root = styled('section')`
  padding: 12px 0 0;
  text-align: initial;
`

export const SeparationRow = styled(TableRow)`
  border-bottom: 1px solid ${props => props.theme.palette.gray[90]};
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding && `${props.padding} !important`};
  }
`

export const Table = styled(BaseTable)`
  border-collapse: collapse !important;
`

export const TableWrapper = styled('div')`
  border: 3px solid ${props => props.theme.palette.gray[95]};
  border-radius: 6px;
  padding: 24px 48px;
  margin: 24px 0 0;
  display: flex;
`

export const HeadToast = styled(BaseToast)`
  & .MuiAlert-message {
    width: 100%;
    padding: 0;
    font-style: italic;
  }
`
export const TableRowWrapper = styled(TableRow)`
  text-align: center;
  color: gray;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledImage = styled('img')`
  width: 80px;
  height: auto;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`

export const InfoWrapper = styled(Grid)`
  text-align: center;
`

export const Label = styled(Typography)`
  font-weight: bold;
  font-size: 16px;
  font-style: normal;
`

export const Value = styled(Typography)`
  margin-top: 8px;
  font-size: 16px;
  font-style: normal;
`

export const StatusToast = styled(HeadToast)`
  display: flex;
  align-items: center;
`
